<template>
  <div class="bg-white">
    <top-page />
    <middle-page />
    <bottom-page />
    <landing-footer />
  </div>
</template>

<script>
  import TopPage from './components/TopPage'
  import MiddlePage from './components/MiddlePage';
  import BottomPage from './components/BottomPage';
  import LandingFooter from './components/LandingFooter';

  export default {
    name: 'LandingPage',
    components: {
      TopPage,
      MiddlePage,
      BottomPage,
      LandingFooter,
    }
  }
</script>
